interface Config {
  mode: string
  REST_API_URLS: string
  APP_ENGINE_URLS: string
  REPORTING_URL?: string
}

const config: { [key: string]: Config } = {
  development: {
    mode: 'dev',
    REST_API_URLS: 'https://staging.backend.leadconnectorhq.com',
    APP_ENGINE_URLS: 'https://staging.backend.leadconnectorhq.com',
    REPORTING_URL: 'https://staging.backend.leadconnectorhq.com/reporting',
  },
  staging: {
    mode: 'staging',
    REST_API_URLS: 'https://staging.backend.leadconnectorhq.com',
    APP_ENGINE_URLS: 'https://staging.backend.leadconnectorhq.com',
    REPORTING_URL: 'https://staging.backend.leadconnectorhq.com/reporting',
  },
  interop: {
    mode: 'interop',
    REST_API_URLS: 'https://interop.backend.leadconnectorhq.com',
    APP_ENGINE_URLS: 'https://interop.backend.leadconnectorhq.com',
    REPORTING_URL: 'https://interop.backend.leadconnectorhq.com/reporting',
  },
  beta: {
    mode: 'beta',
    REST_API_URLS: 'https://backend.leadconnectorhq.com',
    APP_ENGINE_URLS: 'https://backend.leadconnectorhq.com',
    REPORTING_URL: 'https://backend.leadconnectorhq.com/reporting',
  },
  production: {
    mode: 'production',
    REST_API_URLS: 'https://backend.leadconnectorhq.com',
    APP_ENGINE_URLS: 'https://backend.leadconnectorhq.com',
    REPORTING_URL: 'https://backend.leadconnectorhq.com/reporting',
  },
}

const override = false

const overrideConfig = {
  override: true,
}
//@ts-ignore
const envConfig = config[process.env.NODE_ENV]

export default override ? { ...envConfig, ...overrideConfig } : envConfig
